export const peopleContainer = {
    width:'125px',
    textAlign:'center',
    cursor:'pointer',
    '@media (max-width: 768px)' : {
        display:'flex',
        flexDirection:'column',
        justifyContent:'center',
        alignItems:'center'
    },

    '@media (max-width: 468px)' : {
        alignItems: 'center',
        justifyContent: 'space-evenly',
        maxWidth: '140px',
    }
}

export const peopleBox = {
    width:'125px',
    height:'125px',
    margin:'0 auto',
    borderRadius:'50%',
    overflow:'hidden',
    }
